export const homeValues =
{
    // MAIN
    main: 'Main',
    back: 'Welcome back',
    edit: 'Edit profile',
    editToolTip: 'Click here',
    editProfileToolTip: 'Click here to change profile pic',
    questionhead: 'HAVE QUESTION? ',
    questionContent: 'Call us anytime, 866.646.0200 Or email prohelp@spekwo.com ',
    wouldLike: 'What would you like to do today?',
    jobBtnText: 'Check out Job’s',
    profileBtnText: 'Adjust my Profile & Settings',
    inviteBtnText: 'Invite other Pros',
    facts: 'speKwo Facts',
    factsText: 'Did you know only 3 out of 10 pro’s interviewed have skills in multiple trades.',
    logoutTip: 'Click here to logout',

    // TABS
    backToMain: 'Back',
    noView: 'No views added',
    dashboard: 'dashboard',
    job: 'job',
    profile: 'profile',
    invitePros: 'invitePros',

    // JOBS

    //NEW JOBS
    dashboardJobAccept: 'dashboardJobAccept',
    dashboardJobDecline: 'dashboardJobDecline',
    dashboardScope: 'dashboardScope',
    moreInfo: 'moreInfo',

    // AFTER ACCEPT
    acceptHeading: 'Jobs in Progress',
    proCusInfo: 'Customer Info',
    proCusContact: 'Contact Info',
    proCusWorkType: 'Work Type',
    name: 'Customer Name',
    address: 'Address',
    email: 'Email',
    jobType: 'Job Type',
    phone: 'Phone',
    cell: 'Cell',
    value: 'Value of Approved work',
    homeIns: 'Original home inspection report',
    'homeInspectionReport': 'homeInspection',
    proView: 'Pro View',
    proViewHead: 'speKwo Solution Estimate',
    idLabel: 'speKwo Unique ID',
    idContent: 'to view your solution estimate or approve work go to  client.spekwo.com   and enter your unique ID. ',
    proViewDownload: 'Download Pdf',
    proViewClose: 'Close',
    scopeOfWork: 'speKwo estimate of work',
    noAcceptJobs: 'No accepted jobs',
    homeInspectionList: 'Home Inspection List',
    accepted: 'Accepted',
    jobScope: 'jobScope',
    scopeWork: 'scopeWork',
    jobAccept: 'jobAccept',
    jobDecline: 'jobDecline',

    // BEFORE ACCEPT
    approveHeading: 'Guaranteed Work',
    dashboardHeading: 'Guaranteed Work – New Jobs',
    cusInfo: 'Customer Info',
    cusWorkType: 'Work Type',
    cusScope: 'Detailed scope of customer approved work',
    originalSolution: 'Original and Complete Solution Estimate',
    cusValue: 'Value of Work',
    cusLead: 'Cost of Lead',
    categories: 'Categories of Work',
    more: 'More Details',
    originalEsti: 'Original and Complete Solution Wstimate',
    accept: 'Accept Work',
    fetchMore: 'Load more jobs',
    // Decline

    reject: 'Decline Work',
    declineHead: 'Job Decline Page',
    declineContent: 'Pro,',
    declineContent1: ' we appreciate you taking the time to decline this job so another Pro can have a crack at it.',
    declineContent2: 'Please share with us why this job was not a good fit for you.',
    declineReason: {
        declineReason1: 'I don’t know how to handle some items in scope of work',
        declineReason2: 'Scope of work was not estimated high enough',
        declineReason3: 'Location not ideal',
        declineReason4: 'My schedule is too busy',
    },
    proceedDecline: 'Proceed to Decline',

    // Accept

    acceptHead: 'Job Acceptance Page',
    acceptBody: 'Thank you for choosing to handle this work. You received this work without having to compete with any other Pro. You keep doing a great job!  Please follow next steps for payment checkout so you can get in touch with customer.',
    acceptCheckHeaading: 'Work Description Check',
    checkCusName: 'Customer Name',
    checkWorkType: 'Work Type',
    checkHighlightText: '* Immediately upon checkout the customer contact info will appear on your dashboard',
    checkbox1: 'I have reviewed the speKwo Pro ',
    checkTerms: 'terms and conditions',
    checkbox2: 'I agree to contact customer in next 8 hours to schedule the work.',
    checkbox3: 'If I sub-contract out any of the scope of work i agree to take responsibility for the quality control and completion of the work sub-contracted',
    proceedAccept: 'Proceed to Checkout',

    noApprovedJobs: 'speKwo work moves fast, be the first to accept the work when it comes across, dont worry more will available soon.',
    paymentHead: 'Payment',
    paymentContent: 'Pro, thanks for keeping your card on file. That is the one that will be charged for',
    cardInfo: 'Card Info',
    submitPayment: 'Submit Payment',
    payWithCard: 'Payment with saved card',

    //Congrats popup
    congratsHead: 'Congratulations',
    congrats: 'Well done ',
    congrats1: 'The customer contact info has been emailed to you AND will now also appear on your Pro speKwo page under “View Jobs”. ',
    congrats2: 'Remember to maintain your Pro credibility score you need to make contact with the customer in the next 8 business hours.',
    congrats3: 'Once contact has been made and job appointment set you are required to update your dashboard with the appropriate following status as it pertains to you.',
    congrats4: 'A happy customer is a repeat customer! ',


    //SCOPE OR WORK BUTTON

    tableHeading: {
        Category: 'Category',
        Solution: 'Solution',
        description: 'Description',
        Totalcost: 'Totalcost',

    },
    noScopes: 'No work has beed accepted by customer',

    // PROFILES
    proInfo: 'Pro Info',
    credibility: 'Credibility Center',
    skills: 'Got Skills?',
    creditAreaHeading: 'Credibility Approval Area',

    //Pro info
    //Edit field
    logoPicPlace: 'Logo',
    companyName: 'Your Company Name',
    firstName: 'Your First Name',
    lastName: 'Your Last Name',
    profilePicPlace: 'Your Picture (pictures make customers feel better, upload your most professional headshot)',
    addressPlace: 'Address',
    emailPlace: 'Primary Email',
    emailExist: 'Already email exist',
    website: 'Website',
    phoneNumber: 'Cell Phone Number',
    payment: 'Payment Info',
    settings: 'Your Settings',
    createCustomer: 'Save Payment Info',
    createCusCardInfo: 'Card Info',
    savePayment: 'Save details',

    //Credibility area
    bgCheck: 'Click here to have your Background Check Completed',
    insurance: 'Click here to upload your Certificate of Insurance',
    uploadId: 'Click here to upload copy of your ID',
    uploadLicense: 'Click here to upload any license info you want us to see',
    cusRefrence: 'Click here to enter previous customer references',
    proQuestionaire: 'Click here to complete your Pro Questionaire',
    completed: 'completed',
    reference: 'Reference',
    questionarre: 'Questionaire',
    // refrence page
    refHeading: 'References',
    refBody: 'Please provide references.  We are fully aware you are not going to list people that hate you, however we mostly want to hear from people who like you and/or your work.',
    qualityRef: 'Quality of Work References',
    qualityColumn: {
        name: 'Name',
        phone: 'Phone',
        email: 'Email'
    },
    personRef: 'Personality References',
    personColumn: {
        name: 'Name',
        phone: 'Phone',
        email: 'Email'
    },
    refSubmit: 'Submit',

    uploadDocument: 'Start Upload',
    uploadConfirm: 'Are you sure you want to upload this ',

    //Questionarie
    quesHeading: 'Pro-Questionaire',
    quesContent: 'These questions are so we can know you better.',
    picStoryHead: 'Picture Story',
    picStoryContent: 'please upload a picture of a project and tell us why you remember most about that one.  It could be a great customer, the challenge you faced, or even something you wish to forget. Just share ',
    picSubmit: 'SUBMIT',

    dropHeading: 'Complete your Profile by telling us what you or your team CAN handle',
    dropHeading1: 'Are you a Jack of all trades? Or Focused on one?',
    dropOption: 'Choose an option',
    submit: 'Submit',
    skill: 'The Skills',
    proficiency: 'Proficiency',
    license: 'Licensed for this?'

}
export const skills = [
    {
        key: 'roughCarpentry', //For dropdown refernce in db
        keyRadio: 'roughRadio', //For radio refernce in db
        temp: 'Rough Carpentry',
        label: 'Rough Carpentrys',
    },
    {
        key: 'finishCarpentry',
        keyRadio: 'finishRadio',
        label: 'Finish Carpentry',
    },
    {
        key: 'plumbing',
        keyRadio: 'plumbingRadio',
        label: 'Plumbing',
    },
    {
        key: 'electrical',
        keyRadio: 'electricalRadio',
        label: 'Electrical',
    },
    {
        key: 'hvac',
        keyRadio: 'hvacRadio',
        label: 'HVAC',
    },
    {
        key: 'exteriorRoofingSidingGutters',
        keyRadio: 'exteriorRadio',
        label: 'Exterior (roofing/siding/gutters)',
    },
    {
        key: 'sheetrockInstall',
        keyRadio: 'sheetrockInstallRadio',
        label: 'Sheetrock Install',
    },
    {
        key: 'sheetrockFinish',
        keyRadio: 'sheetrockFinishRadio',
        label: 'Sheetrock install & finish',
    },
    {
        key: 'paint',
        keyRadio: 'paintRadio',
        label: 'Paint',
    },
    {
        key: 'appliances',
        keyRadio: 'appliancesRadio',
        label: 'Appliances',
    },
    {
        key: 'windowDoors',
        keyRadio: 'windowDoorsRadio',
        label: 'Window & Doors',
    },
    {
        key: 'handymanWork',
        keyRadio: 'handymanWorkRadio',
        label: 'Handyman work',
    },
    {
        key: 'generalRemodel',
        keyRadio: 'generalRemodelRadio',
        label: 'General Remodel',
    },
    {
        key: 'bathroomRemodeling',
        keyRadio: 'bathroomRemodelingRadio',
        label: 'Bath / Kit Remodel',
    }
];
export const skillDropdown = [
    {
        key: 'Heard of It',
        label: 'Heard of It',
    },
    {
        key: 'I know how',
        label: 'I know how',
    },
    {
        key: 'I am a skilled',
        label: "I'm a skilled",
    },
    {
        key: 'I am a Pro',
        label: "I'm a Pro",
    },
    {
        key: 'I am the best!',
        label: 'I am the best!',
    }
];
export const skillRadio = [
    {
        key: 'Yes',
        label: 'Yes',
    },
    {
        key: 'No',
        label: 'No',
    },
    {
        key: 'N/A',
        label: 'N/A',
    }
]




// WEBPACK FOOTER //
// E:/NeoSME/1.Full Project Spekwo/pro/prodash/src/app/main/content/apps/utils/home.ts